<div class="row">
    <div class="col-12 information-text">
        {{ message }}
        <br />
        <br />
        <nb-icon
            class="empty-icon"
            pack="regular"
            icon="fa-frown-open"
        ></nb-icon>
    </div>
</div>
